import { Image } from "services/images";

export const UploadImage = ({ label, imageUrl, onChange }: Props) => {
  const innerOnChange = async (ev: React.ChangeEvent<HTMLInputElement>) => {
    const files = ev.target?.files;
    if (files) {
      const file = files[0];
      const image: Image = {
        id: -1,
        originalName: file.name,
        generatedName: "",
        contentType: file.type,
        url: URL.createObjectURL(file),
        buffer: await file.arrayBuffer(),
      };
      onChange(image);
    }
  };

  const removeClicked = (ev: any) => {
    ev.preventDefault();
    onChange(null);
  };

  return (
    <div className="flex-col space-y-1">
      <label
        htmlFor="cover-photo"
        className="block text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      <div className="flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
        {imageUrl && (
          <div className="flex-column text-center">
            <button className="mb-10" onClick={removeClicked}>
              Remove
            </button>
            <img src={imageUrl} className="object-contain max-h-96" alt="" />
          </div>
        )}
        {!imageUrl && (
          <div className="space-y-1 text-center">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="text-sm text-gray-600">
              <label
                htmlFor="file-upload"
                className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
              >
                <span>Upload a file</span>
                <input
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  className="sr-only"
                  onChange={innerOnChange}
                  accept=".jpg,.png,.jpeg"
                />
              </label>
            </div>
            <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
          </div>
        )}
      </div>
    </div>
  );
};

interface Props {
  imageUrl?: string;
  label: string;
  onChange: (image: Image | null) => void;
}
